import { createFileRoute, Outlet } from '@tanstack/react-router'
import { MatterportWalkthrough } from 'pages/matterport/MatterportWalkthrough'

export const Route = createFileRoute('/walkthrough/{-$siteID}')({
  component: RouteComponent,
  staticData: {
    title: 'Gecko Cantilever Walkthrough',
  },
})

function RouteComponent() {
  const params = Route.useParams()
  const siteID = params.siteID

  if (!siteID) {
    return <Outlet />
  }

  return <MatterportWalkthrough />
}
